{
  "name": "rtm-cpm",
  "version": "0.2.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local --open",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --watch=false --code-coverage",
    "lint": "eslint -c .eslintrc.json --ext=.tsx,.ts src",
    "lint-fix": "npm run lint -- --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.6",
    "@angular/cdk": "^20.1.5",
    "@angular/common": "^20.1.6",
    "@angular/compiler": "^20.1.6",
    "@angular/core": "^20.1.6",
    "@angular/forms": "^20.1.6",
    "@angular/material": "^20.1.5",
    "@angular/platform-browser": "^20.1.6",
    "@angular/platform-browser-dynamic": "^20.1.6",
    "@angular/router": "^20.1.6",
    "@azure/msal-angular": "^4.0.7",
    "@azure/msal-browser": "^4.8.0",
    "@fortawesome/angular-fontawesome": "0.10.2",
    "@fortawesome/fontawesome-free": "^6.4.0",
    "@fortawesome/fontawesome-svg-core": "^6.1.1",
    "@fortawesome/free-solid-svg-icons": "^6.4.0",
    "@scania/tegel-angular-17": "^1.35.0",
    "bootstrap": "^5.3.7",
    "package": "^1.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.1.5",
    "@angular-eslint/eslint-plugin": "^20.1.1",
    "@angular-eslint/eslint-plugin-template": "^20.1.1",
    "@angular-eslint/template-parser": "^20.1.1",
    "@angular/cli": "^20.1.5",
    "@angular/compiler-cli": "^20.1.6",
    "@types/jasmine": "^5.1.8",
    "@types/jquery": "^3.5.29",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "@webcomponents/webcomponentsjs": "^2.6.0",
    "eslint": "^8.57.1",
    "jasmine-core": "^5.9.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "~5.8.2"
  }
}
